import { useEffect, useState } from 'react';

import { servGetTabelaIndicadoresEstabelecimento } from '../../../servicos/graficos_indicador';
import { formataDate } from '../../../util/datas';
import { formataOperadoresRelacionaisV2 } from '../../../util/utilitarios'

function TabelaIndicadorEstabelecimento({ dadosTabela }) {

    console.log('### Iniciando TabelaDetalhamentoIndicadorEstabelecimento ###');
    console.log(dadosTabela);

    return (
        <div className='d-flex flex-wrap'>
            {dadosTabela && dadosTabela.map((indicadoresDoMes) => (
                <div className='p-1 col-4' key={indicadoresDoMes.mesReferenciaFormatado}>
                    <table className='table' border="1">
                        <thead>
                            <tr className=''>
                                <th
                                    style={{ 'backgroundColor': '#f5f3f3' }}
                                    className='text-center'
                                    colSpan="5"
                                >
                                    {indicadoresDoMes.mesReferenciaFormatado}
                                </th>
                            </tr>
                            <tr>
                                <th>Indicador</th>
                                <th>Meta</th>
                                <th>Resultado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {indicadoresDoMes.indicadores.map((indicador) => (
                                <tr
                                    className={
                                        indicador.nsa
                                            ? 'default'
                                            :
                                            indicador.metaAlcancada
                                                ? 'table-success'
                                                : 'table-danger'
                                    }
                                    key={indicador.indicadorId}
                                >
                                    <td>{indicador.metricaCodigo}</td>
                                    <td>{formataOperadoresRelacionaisV2(indicador.metaNumero, indicador.metaOperador, indicador.resultadoEmPorcentagem)}</td>
                                    <td>{indicador.nsa ? 'NSA' : indicador.resultado}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div >
    )
}

export default TabelaIndicadorEstabelecimento
